<template>
    <div>
        <div class="custom-table governance directors-meeting" v-if="$i18n.locale=='en'"> 
            <div class="table-heading">Board of Directors’ Meetings:</div>
            <div class="trow head border-0 bg-green">
                <div class="th">NAME </div>
                <div class="th text-center">MEETING no. 1<br> 12/2/2020</div>
                <div class="th text-center">MEETING no.2<br>14/4/2020</div>
                <div class="th text-center">MEETING no. 3<br>15/7/2020</div>
                <div class="th text-center">MEETING no. 4<br>3/11/2020</div>
                <div class="th text-center">MEETING no. 5<br>23/12/2020</div>
                <div class="th text-center">TOTAL<br>ATTENDED</div>
            </div>
            <div class="trow">
                <div><strong>Ahmed Tahous Al Tahous</strong><br>Chairman</div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="trow">
                <div><strong>Bader Nasser Al Kharafi</strong><br>Vice Chairman and
                    Group CEO</div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="trow">
                <div><strong>Talal Said<br> Al Mamari</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="trow">
                <div><strong>Zaki Hilal Saud<br> Al Busaidi</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">4</div>
            </div>
            <div class="trow">
                <div><strong>Atif Said Rashid<br> Al Siyabi</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">4</div>
            </div>
            <div class="trow">
                <div><strong>Aladdin Baitfadhil</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">2</div>
            </div>
            <div class="trow">
                <div><strong>Nasser bin Suleiman<br> Al-Harthy</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">1</div>
            </div>
            <div class="trow">
                <div><strong>Abdulrahman Mohammad Ibrahim<br> Al Asfour</strong><br> Independent</div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="trow">
                <div><strong>Yousef Khaled<br> Al-Abdulrazzaq</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="trow">
                <div><strong>Hatmal Farouq<br> Al Qadi</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="table-heading b-top-0">Previous Members</div>
            <div class="trow">
                <div><strong>Martial Caratti</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">3</div>
            </div>
            <div class="trow">
                <div><strong>Nigel Covett</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">1</div>
            </div>
            <div class="trow">
                <div><strong>Abdullah Al Harthy</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">2</div>
            </div>
            <div class="trow">
                <div><strong>Saud Al Nahari</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">1</div>
            </div>
            <div class="trow">
                <div><strong>Mahdi Al Abduwan</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">1</div>
            </div>
            <div class="trow grey percentage">
                <div><strong>Percentage of Members in Attendance</strong></div>
                <div class="text-center"><strong>100%</strong></div>
                <div class="text-center"><strong>100%</strong></div>
                <div class="text-center"><strong>100%</strong></div>
                <div class="text-center"><strong>100%</strong></div>
                <div class="text-center"><strong>88.9%</strong></div>
                <div class="text-center">&nbsp;</div>
            </div>
        </div>
         <div class="custom-table governance directors-meeting" v-if="$i18n.locale=='ar'">
            <div class="table-heading">اجتماعات مجلس الإدارة في العام:2020</div>
            <div class="trow head border-0 bg-green">
                <div class="th">اسم العضو </div>
                <div class="th text-center">اجتماع رقم 1<br> 12/2/2020</div>
                <div class="th text-center">اجتماع رقم 2<br>14/4/2020</div>
                <div class="th text-center">اجتماع رقم 3<br>15/7/2020</div>
                <div class="th text-center">اجتماع رقم 4<br>3/11/2020</div>
                <div class="th text-center">اجتماع رقم 5<br>23/12/2020</div>
                <div class="th text-center">عدد<br>الاجتماعات</div>
            </div>
            <div class="trow">
                <div><strong>أحمد طاحوس الطاحوس</strong><br>رئيس مجلس الإدارة</div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="trow">
                <div><strong>بدر ناصر الخرافي</strong><br>نائب رئيس مجلس الإدارة والرئيس التنفيذي للمجموعة</div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="trow">
                <div><strong>طلال بن سعيد<br> المعمري</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="trow">
                <div><strong>زكي بن هلال بن سعود<br> البوسعيدي</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">4</div>
            </div>
            <div class="trow">
                <div><strong>عاطف بن سعيد بن راشد<br>السيابي</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">4</div>
            </div>
            <div class="trow">
                <div><strong>علاء الدين بيت فاضل</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">2</div>
            </div>
            <div class="trow">
                <div><strong>ناصر بن سليمان<br> الحارثي</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">1</div>
            </div>
            <div class="trow">
                <div><strong>عبد الرحمن محمد <br> ابراهيم العصفور</strong><br> مستقل</div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="trow">
                <div><strong>يوسف خالد<br> العبد الرزاق</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="trow">
                <div><strong>حتمل فاروق<br>  القاضي</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center">5</div>
            </div>
            <div class="table-heading b-top-0">الأعضاء السابقون</div>
            <div class="trow">
                <div><strong>مارتيال كاراتي</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">3</div>
            </div>
            <div class="trow">
                <div><strong>نيجيل كوفيت</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">1</div>
            </div>
            <div class="trow">
                <div><strong>عبدالله الحارثي</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">2</div>
            </div>
            <div class="trow">
                <div><strong>سعود النهاري</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">1</div>
            </div>
            <div class="trow">
                <div><strong>مهدي العبدواني</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center">1</div>
            </div>
            <div class="trow grey percentage">
                <div><strong>نسبة الحضور</strong></div>
                <div class="text-center"><strong>100<span class="ltr">%</span></strong></div>
                <div class="text-center"><strong>100<span class="ltr">%</span></strong></div>
                <div class="text-center"><strong>100<span class="ltr">%</span></strong></div>
                <div class="text-center"><strong>100<span class="ltr">%</span></strong></div>
                <div class="text-center"><strong>88.9<span class="ltr">%</span></strong></div>
                <div class="text-center">&nbsp;</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>